import React from "react";
import {
  FaCoins,
  FaKey,
  FaMobileAlt,
  FaFingerprint,
  FaChartLine,
  FaQrcode,
  FaLink,
  FaHistory,
} from "react-icons/fa";
function NonCustodialSecurity() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Key Features of Our Crypto Wallet Mobile App
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={35} />
                      </div>
                      <h4>Multi-Currency Support</h4>
                      <p>
                        Our mobile wallet apps support multiple
                        cryptocurrencies, including Bitcoin (BTC), Ethereum
                        (ETH), Binance Coin (BNB), and a variety of altcoins and
                        tokens. Users can store, send, and receive digital
                        assets all in one place.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaKey size={35} />
                      </div>
                      <h4>Non-Custodial Security</h4>
                      <p>
                        We provide non-custodial wallets, where users have full
                        control over their private keys. Security is ensured
                        with encryption, private key storage, and backup &
                        recovery options, offering complete safety for users'
                        assets.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaMobileAlt size={35} />
                      </div>
                      <h4>Cross-Platform Compatibility</h4>
                      <p>
                        We develop mobile wallet apps for both iOS and Android
                        platforms, ensuring smooth performance and
                        cross-platform compatibility for all users.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaFingerprint size={35} />
                      </div>
                      <h4>Biometric Authentication & 2FA</h4>
                      <p>
                        Our wallets feature biometric authentication
                        (fingerprint or facial recognition) andtwo-factor
                        authentication (2FA) for an added layer of security,
                        preventing unauthorized access.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaChartLine size={35} />
                      </div>
                      <h4>Real-Time Price Tracking & Alerts</h4>
                      <p>
                        Users can monitor real-time price changes and set alerts
                        for specific price movements of their favorite
                        cryptocurrencies. This feature helps users stay informed
                        and make timely decisions.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaQrcode size={35} />
                      </div>
                      <h4>QR Code Payments</h4>
                      <p>
                        Our mobile apps integrate QR code scanning for quick and
                        easy crypto payments, simplifying the process of sending
                        and receiving funds.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLink size={35} />
                      </div>
                      <h4>Integration with Decentralized Finance (DeFi)</h4>
                      <p>
                        For users engaging in DeFi activities, we provide wallet
                        integration with DeFi protocols, enabling features like
                        staking, yield farming, and DApp connectivity directly
                        within the mobile app.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaHistory size={35} />
                      </div>
                      <h4>Transaction History & Management</h4>
                      <p>
                        Users can easily track their transaction history, with
                        detailed breakdowns of each transaction. This ensures
                        transparency and helps users manage their finances more
                        effectively.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NonCustodialSecurity;
